module.exports = "/assets/e12b5ae4cdb91a42f8f03c1d9b14213f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/7H.png
// module id = 2241
// module chunks = 0